define((require, exports, module) => {
    'use strict';

    /**
     * @param {number} time – delay time in milliseconds
     * @returns {Promise}
     */
    function delay(time) {
        let cancel;
        let timeoutId;
        const promise = new Promise((resolve, reject) => {
            cancel = reject;
            timeoutId = setTimeout(resolve, time);
        });

        /**
         * @param {any} reason
         */
        promise.cancel = function(reason) {
            clearTimeout(timeoutId);
            cancel(reason);
        };

        return promise;
    }

    module.exports = delay;
});
